module.exports = __webpack_public_path__ + "img/point.9d4876ec.svg";